import { FormState } from 'react-hook-form/dist/types/form';
import { FieldValues } from 'react-hook-form/dist/types/fields';

export default function isFormDirty<T extends FieldValues = any>(formState: FormState<T>): boolean {
  return Object.keys(formState.dirtyFields).length > 0;
}
